import "./style.css";
import Intro from "./Intro"
const IntroSection = () => {
  return <section className="intro-section-wrapper">
      <Intro />
  </section>;
};
export default IntroSection;
